import React from 'react'

import CreditRequestToastContainer from './CreditRequestToastContainer'

/**
 * Single mount point for ambient credit-driven UI surfaces. Add new
 * credit-related global side effects or portals here so RootContainer stays
 * uncluttered and there's one place to look for "what's reacting to credit
 * state at the app root".
 *
 * Currently:
 *   - Renders the admin "Team Member Requested Credits" toast when the backend
 *     pushes the `credits_requested` socket event (PLG §3.2 / Purchase §3.4).
 *
 * The "AI Credits are available!" toast (PLG §5 / Purchase §3.6) is fired from
 * the socket epic on the `credits_restored` event, not from this component.
 *
 * Mounted once near `<ToastsContainer />` so the toast renders as long as the
 * user is authenticated and the agents slice is populated.
 */
const CreditNotificationsManager = () => <CreditRequestToastContainer />

export default CreditNotificationsManager
